<app-programtitle title="Multiplication tables"></app-programtitle>

<p> This program will print a multiplication table for a given number.</p>

<app-editor code="{{forprogram}}"> </app-editor>


<p> Here is the same program written using while loops.</p>

<app-editor code="{{whileprogram}}"> </app-editor>